import axios from "axios";
import moment from "moment";

export const regexEmail = /^[\w+.]+@\w+\.\w{2,}(?:\.\w{2})?$/;

export const createFormikValidation = (formMap, values) => {
    const errors = {};

    for (let [key, value] of formMap) {
        if (!values[key] && values[key] !== 0) {
            if (value) {
                errors[key] = "O campo " + value + " é obrigatório.";
            } else {
                errors[key] = "O campo é obrigatório.";
            }
        } else if (key.includes("email") && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values[key])) {
            errors[key] = "Você precisa informar um e-mail válido.";
        } else if ((key.includes("senha") || key.includes("password")) && values[key].length < 6) {
            errors[key] = "A senha deve ter pelo menos 6 caracteres.";
        } else if (key.includes("cep") && values[key].length < 5) {
            errors[key] = "Utilize no mínimo 8 caracteres.";
        } else if (key.includes("cpf") && key.includes("cnpj")) {
            if (values[key].length > 14 && !validaCnpj(values[key])) {
                errors[key] = "O CNPJ informado é inválido.";
            } else if (values[key].length <= 14 && !validaCpf(values[key])) {
                errors[key] = "O CPF informado é inválido.";
            }
        } else if (key.includes("cpf") && !validaCpf(values[key])) {
            errors[key] = "O CPF informado é inválido.";
        } else if (key.includes("cnpj") && !validaCnpj(values[key])) {
            errors[key] = "O CNPJ informado é inválido.";
        } else if (key.includes("telefone") && values[key].length < 14) {
            errors[key] = "Utilize no mínimo 14 caracteres.";
        } else if (key.includes("data_nascimento") && moment(values[key]).isAfter(moment())) {
            errors[key] = "A data de nascimento não pode ser uma data futura.";
        }
    }

    return errors;
};

export const shallowEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (let key of keys1) {
        if (object1[key] !== object2[key]) {
            return false;
        }
    }

    return true;
};

export const formatHourInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1:$2");

    input.target.value = value;

    return input;
};

export const formatCNPJInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1/$2");
    value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCPFInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCPForCNPJInput = (input) => {
    if (input?.target?.value?.length > 14) {
        return formatCNPJInput(input);
    } else {
        return formatCPFInput(input);
    }
};

export const formatDataInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");
    value = value.replace(/(\d{2})(\d)/, "$1/$2");

    input.target.value = value;

    return input;
};

export const formatTelefoneInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{0})(\d)/, "$1($2");
    value = value.replace(/(\d{2})(\d)/, "$1) $2");
    value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatCepInput = (input) => {
    let value = input.target.value;

    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{5})(\d)/, "$1-$2");

    input.target.value = value;

    return input;
};

export const formatBRLInput = (input) => {
    input.target.value = Number(input.target.value.toString().replace(/[^0-9-]/g, "")) / 10 ** 2;

    input.target.value = formatBRL(input.target.value);

    return input;
};

export const formatDecimal = (input) => {
    input.target.value = Number(input.target.value.toString().replace(/[^0-9-]/g, "")) / 10 ** 2;

    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "decimal",
        minimumFractionDigits: 2,
    });

    input.target.value = formatter.format(input.target.value);

    return input;
};

export const formatBRL = (value) => {
    const formatter = new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
    });

    value = formatter.format(value);

    return value;
};

export const formatIntegerInput = (input) => {
    if (input.target.value == "") {
        input.target.value = "";
        return input;
    }

    input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ""));
    return input;
};

export const buscaCep = (input, setFieldValue, nomeEndereco, nomeBairro, nomeCidade, nomeUf, onLoading) => {
    if (input.target.value.length > 8) {
        var cep = input.target.value.replace(/[^0-9]/, "");

        const instance = axios.create();

        if (onLoading) {
            onLoading(true);
        }

        instance
            .get(`https://viacep.com.br/ws/${cep}/json/`, {})
            .then((res) => {
                if (res.data.erro) {
                    setFieldValue(nomeEndereco, "");
                    setFieldValue(nomeBairro, "");
                    setFieldValue(nomeCidade, "");
                    setFieldValue(nomeUf, "");
                } else {
                    setFieldValue(nomeEndereco, res.data.logradouro ?? "");
                    setFieldValue(nomeBairro, res.data.bairro ?? "");
                    setFieldValue(nomeCidade, res.data.localidade ?? "");
                    setFieldValue(nomeUf, res.data.uf ?? "");
                }
            })
            .catch((err) => {})
            .finally(() => {
                if (onLoading) {
                    onLoading(false);
                }
            });
    }

    return formatCepInput(input);
};

export const fetchCitiesByUF = async (uf, onLoading, onData) => {
    if (uf) {
        const instance = axios.create();

        if (onLoading) {
            onLoading(true);
        }

        await instance
            .get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${uf}/municipios`, {})
            .then((res) => {
                if (res.data?.length) {
                    onData(res.data);
                }
            })
            .catch(() => {
                onData([]);
            })
            .finally(() => {
                if (onLoading) {
                    onLoading(false);
                }
            });
    } else {
        onData([]);
    }
};

export const limparMoeda = (valor) => {
    valor = valor.replace("R$", "");
    valor = valor.replaceAll(".", "");
    valor = valor.replace(",", ".");
    valor = valor.replace("/^p{Z}+|p{Z}+$/u", "");
    valor = valor.trim();

    return valor;
};

export const clearString = (value) => {
    value = value.replace(/[^a-zA-Z0-9]/g, "");
    return value;
};

export const listaUfs = ["AC", "AL", "AM", "AP", "BA", "CE", "DF", "ES", "GO", "MA", "MG", "MS", "MT", "PA", "PB", "PE", "PI", "PR", "RJ", "RN", "RO", "RR", "RS", "SC", "SE", "SP", "TO"];

export const listaSimNao = [
    { value: 1, label: "Sim" },
    { value: 0, label: "Não" },
];

export const displayValueCurrency = (value) => {
    return value ? `R$ ${value.toLocaleString("pt-BR", { minimumFractionDigits: 2 }).replace(".", ",")}` : "Não disponível";
};

export const displayValueFixed = (value, casas) => {
    return value ? value.toFixed(casas) : "Não disponível";
};

export const displayValuePercent = (value) => {
    return value ? `${value.toLocaleString("pt-BR", { minimumFractionDigits: 2 })} %` : "Não disponível";
};

/* eslint-disable */
export const validaCpf = (cpf) => {
    var add = 0;
    var rev = 0;

    cpf = cpf.replace(/[^\d]+/g, "");
    if (cpf == "") return false;

    if (cpf.length != 11) return false;

    for (var i = 0; i < 9; i++) {
        add += parseInt(cpf.charAt(i)) * (10 - i);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }
    if (rev != parseInt(cpf.charAt(9))) {
        return false;
    }

    add = 0;

    for (var j = 0; j < 10; j++) {
        add += parseInt(cpf.charAt(j)) * (11 - j);
    }

    rev = 11 - (add % 11);

    if (rev == 10 || rev == 11) {
        rev = 0;
    }

    if (rev != parseInt(cpf.charAt(10))) {
        return false;
    }

    return true;
};
/* eslint-enable */

export const validaCnpj = (cnpj) => {
    cnpj = cnpj.replace(/[^\d]+/g, "");

    if (cnpj.length !== 14) {
        return false;
    }

    if (/^(\d)\1+$/.test(cnpj)) {
        return false;
    }

    let add = 0;
    let rev = 0;
    let pos = 5;

    for (let i = 0; i < 12; i++) {
        add += parseInt(cnpj.charAt(i)) * pos;
        pos = pos === 2 ? 9 : pos - 1;
    }

    rev = add % 11 < 2 ? 0 : 11 - (add % 11);

    if (rev !== parseInt(cnpj.charAt(12))) {
        return false;
    }

    add = 0;
    pos = 6;

    for (let i = 0; i < 13; i++) {
        add += parseInt(cnpj.charAt(i)) * pos;
        pos = pos === 2 ? 9 : pos - 1;
    }

    rev = add % 11 < 2 ? 0 : 11 - (add % 11);

    if (rev !== parseInt(cnpj.charAt(13))) {
        return false;
    }

    return true;
};

export const formatPercentageInput = (input) => {
    if (input.target.value == "") input.target.value = 0;
    input.target.value = Number(input.target.value.toString().replace(/[^0-9]/g, ""));
    if (input.target.value == 0) input.target.value = 0;
    if (input.target.value > 100) input.target.value = "100";
    return input;
};

export const saudacao = () => {
    const data_atual_format = moment().format("YYYY-MM-DD");
    const inicio_manha = moment(`${data_atual_format} 6:00:00`, "YYYY-MM-DD HH:mm:ss");
    const fim_manha = moment(`${data_atual_format} 12:00:00`, "YYYY-MM-DD HH:mm:ss");
    const inicio_tarde = moment(`${data_atual_format} 12:00:00`, "YYYY-MM-DD HH:mm:ss");
    const fim_tarde = moment(`${data_atual_format} 18:00:00`, "YYYY-MM-DD HH:mm:ss");
    const data_atual = moment();

    if (data_atual.isBetween(inicio_manha, fim_manha)) {
        return "Bom dia";
    } else if (data_atual.isBetween(inicio_tarde, fim_tarde)) {
        return "Boa tarde";
    } else {
        return "Boa noite";
    }
};

export const textoExclusao = {
    title: "Atenção!",
    text: "Tem certeza que deseja remover esse registro?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    cancelButtonText: "Não",
    confirmButtonText: "Sim",
};

export const listaTipoDocumento = [
    { id: 1, name: "CRAS - Conselho Regional de Assistência Social (CRAS)" },
    { id: 2, name: "COREN - Conselho Regional de Enfermagem (COREN)" },
    { id: 3, name: "CRF - Conselho Regional de Farmácia (CRF)" },
    { id: 4, name: "CRFA - Conselho Regional de Fonoaudiologia (CRFA)" },
    { id: 5, name: "CREFITO - Conselho Regional de Fisioterapia e Terapia Ocupacional (CREFITO)" },
    { id: 6, name: "CRM - Conselho Regional de Medicina (CRM)" },
    { id: 7, name: "CRN - Conselho Regional de Nutrição (CRN)" },
    { id: 8, name: "CRO - Conselho Regional de Odontologia (CRO)" },
    { id: 9, name: "CRP - Conselho Regional de Psicologia (CRP)" },
    { id: 10, name: "Outros - Outros Conselhos" },
];

export const periodicidadeExibicao = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60];

export const listaEstadoCivil = [
    { label: "Solteiro", value: "Solteiro" },
    { label: "Casado", value: "Casado" },
    { label: "Separado", value: "Separado" },
    { label: "Divorciado", value: "Divorciado" },
    { label: "Viúvo", value: "Viúvo" },
];

export const listaPeridizacao = [
    { label: "Horas", value: "Horas" },
    { label: "Dias", value: "Dias" },
    { label: "Semanas", value: "Semanas" },
    { label: "Meses", value: "Meses" },
    { label: "Anos", value: "Anos" },
];

export const listaTipoProtocolo = [
    { label: "Medicamento", value: "Medicamento" },
    { label: "Atividade física", value: "Atividade física" },
];

export const calculoIMC = (peso, altura) => {
    const peso_formatado = Number(limparMoeda(peso));
    const altura_formatada = Number(altura) / 100;

    if (altura_formatada > 0) {
        return (peso_formatado / (altura_formatada * altura_formatada)).toFixed(2).replace(".", ",");
    } else {
        return "0,00";
    }
};

export const listaSexo = [
    { label: "Masculino", value: "Masculino" },
    { label: "Feminino", value: "Feminino" },
];

export const formatarDiaSemana = (dia) => {
    const dia_str = dia.replace("-feira", "");

    return dia_str.charAt(0).toUpperCase() + dia_str.slice(1);
};

export const formatNumerosPositivos = (input) => {
    const value = input.target.value;

    if ((!/^\d*$/.test(value) && value !== "") || isNaN(value) || value === "0") {
        input.target.value = 1;
    }

    return input;
};

export const formatBytesLabel = (bytes, decimals = 2) => {
    if (!+bytes) return "0 Bytes";

    const k = 1000; // Base 10 para MB (MB != MiB)
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

export const isset = (value) => value !== null && value !== undefined;

export const formatarCelularComCodigoPais = (numero) => {
    const somenteNumeros = numero.replace(/\D/g, "");

    // Verifica se começa com código do Brasil (55)
    if (somenteNumeros.length >= 12 && somenteNumeros.startsWith("55")) {
        const ddd = somenteNumeros.slice(2, 4);
        const celular = somenteNumeros.slice(4);

        if (celular.length === 9) {
            const parte1 = celular.slice(0, 5);
            const parte2 = celular.slice(5);
            return `+55 (${ddd}) ${parte1}-${parte2}`;
        } else if (celular.length === 8) {
            const parte1 = celular.slice(0, 4);
            const parte2 = celular.slice(4);
            return `+55 (${ddd}) ${parte1}-${parte2}`;
        }
    }

    // Se não estiver no formato esperado, retorna como está
    return numero;
};

export const getCardFlag = (value) => {
    const card = value?.replace(/[^0-9]+/g, "");

    const cards = {
        elo: /^(4011|4312|4389|4514|4576|5041|5067|5090|6277|6362|6363|6504|6505|6507|6509|6516|6550|6551|6552)\d{12,15}$/,
        visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
        mastercard: /^5[1-5][0-9]{14}$/,
        diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
        discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/,
        hipercard: /^6062|3841/,
        jcb: /^(?:2131|1800|35\d{3})\d{11}$/,
        amex: /^3[47][0-9]{13}$/,
        aura: /^50[0-9]{14}$/,
    };

    for (const flag in cards) {
        if (cards[flag].test(card)) {
            return flag;
        }
    }

    return false;
};

export const formatNumeroCartao = (input, cardFlag = null) => {
    const cleaned = input.target.value.replace(/[^0-9*]/g, "");
    const cardType = cardFlag ?? getCardFlag(cleaned);

    // Aplica a máscara conforme o tipo
    switch (cardType) {
        case "amex": // 15 dígitos: #### ###### #####
            input.target.value = cleaned.replace(/^([\d\*]{0,4})([\d\*]{0,6})([\d\*]{0,5})/, "$1 $2 $3").trim();
            break;
        case "diners": // 14 dígitos: #### ###### ####
            input.target.value = cleaned.replace(/^([\d\*]{0,4})([\d\*]{0,6})([\d\*]{0,4})/, "$1 $2 $3").trim();
            break;
        case "elo":
        case "hipercard":
        case "visa":
        case "mastercard":
        case "discover":
        case "jcb":
        default:
            // Até 19 dígitos, formatado em blocos de 4
            input.target.value = cleaned.replace(/(.{1,4})/g, "$1 ").trim();
            break;
    }

    return input;
};

export const JSONCompare = (obj1, obj2) => {
    return JSON.stringify(obj1) === JSON.stringify(obj2);
};

export const sanitizeText = (text) => {
    return (text ?? "")
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "") // Remove acentos
        .replace(/\s+/g, "_") // 1. Substitui um ou mais espaços por UM underline
        .replace(/[^a-zA-Z0-9_]/g, ""); // 2. Remove o resto, mas mantém o underline
};

export const formatTextInput = (input) => {
    if (input.target.value == "") {
        input.target.value = "";
        return input;
    }

    input.target.value = sanitizeText(input.target.value);
    return input;
};

export const setFavicon = (url) => {
    const links = document.querySelectorAll("link[rel*='icon']");
    links.forEach((link) => link.parentNode.removeChild(link));

    const newLink = document.createElement("link");
    newLink.rel = "icon";
    newLink.type = "image/png";
    newLink.href = url;

    document.head.appendChild(newLink);
};

/**
 * Compacta um arquivo de imagem (File) e retorna um novo arquivo compactado (File).
 * @param {File} imageFile - O objeto File da imagem a ser compactada.
 * @param {number} quality - A qualidade da compressão (0.0 a 1.0).
 * @returns {Promise<File>} Uma Promise que resolve para o novo objeto File compactado.
 */
export const compressImageFile = (imageFile, quality = 0.8) => {
    return new Promise((resolve, reject) => {
        // 1. Verificar se é um arquivo de imagem
        if (!imageFile.type.startsWith("image/")) {
            reject(new Error("O arquivo não é uma imagem."));
            return;
        }

        const reader = new FileReader();

        reader.onload = (event) => {
            const img = new Image();

            img.onload = () => {
                // 3. Desenhar a imagem em um elemento Canvas
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, img.width, img.height);

                // 4. Exportar o conteúdo do Canvas com compressão para um Blob
                // O método toBlob é assíncrono. Usamos o formato 'image/jpeg' ou o tipo original
                const outputType = imageFile.type === "image/png" ? "image/jpeg" : imageFile.type;

                canvas.toBlob(
                    (blob) => {
                        if (!blob) {
                            reject(new Error("Falha na compressão do Canvas para Blob."));
                            return;
                        }

                        // Criar um novo objeto File a partir do Blob
                        // O novo arquivo terá o mesmo nome, mas o conteúdo compactado
                        const compressedFile = new File([blob], imageFile.name, {
                            type: outputType,
                            lastModified: Date.now(),
                        });

                        resolve(compressedFile);
                    },
                    outputType,
                    quality,
                ); // <-- Aqui definimos a qualidade da compressão (ex: 0.8)
            };

            img.onerror = () => {
                reject(new Error("Falha ao carregar a imagem."));
            };

            // 2. Carregar o Data URL (event.target.result)
            img.src = event.target.result;
        };

        reader.onerror = (error) => {
            reject(error);
        };

        reader.readAsDataURL(imageFile);
    });
};

export const formatLargeNumberToString = (num) => {
    const format = ({ value, minimumFractionDigits, maximumFractionDigits }) => {
        const formatter = new Intl.NumberFormat("pt-BR", {
            style: "decimal",
            minimumFractionDigits,
            maximumFractionDigits,
        });

        return formatter.format(value);
    };

    if (num >= 1e9) {
        return format({ value: num / 1e9, maximumFractionDigits: 1 }) + "b"; // Bilhão
    } else if (num >= 1e6) {
        return format({ value: num / 1e6, maximumFractionDigits: 1 }) + "m"; // Milhão
    } else if (num >= 1e3) {
        return format({ value: num / 1e3, maximumFractionDigits: 1 }) + "k"; // Milha
    } else {
        return num.toString(); // Menos que uma milha
    }
};

export const formatCPF = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");

    return value;
};

export const formatCNPJ = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{2})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1.$2");
    value = value.replace(/(\d{3})(\d)/, "$1/$2");
    value = value.replace(/(\d{4})(\d{1,2})$/, "$1-$2");

    return value;
};

export const formatTelefone = (value) => {
    value = value.replace(/\D/g, "");
    value = value.replace(/(\d{0})(\d)/, "$1($2");
    value = value.replace(/(\d{2})(\d)/, "$1) $2");
    value = value.replace(/(\d{1})(\d{1,4})$/, "$1-$2");

    return value;
};

export const daysOfWeek = [
    { key: "monday", label: "Segunda-feira" },
    { key: "tuesday", label: "Terça-feira" },
    { key: "wednesday", label: "Quarta-feira" },
    { key: "thursday", label: "Quinta-feira" },
    { key: "friday", label: "Sexta-feira" },
    { key: "saturday", label: "Sábado" },
    { key: "sunday", label: "Domingo" },
];
